import { render } from "./FormSwitchRow.vue?vue&type=template&id=6493cd20"
import script from "./FormSwitchRow.vue?vue&type=script&lang=js"
export * from "./FormSwitchRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__